import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';


const StyledContactSection = styled.section`
  background-color: var(--themeColor);
  color: #fff;
  text-align: center;
  max-width: initial;
  margin: 50px auto 0px;
  padding: 150px 100px;

  @media (max-width: 768px) {
    margin: 70px auto 0px;
    padding: 100px 15px;
  }

  h3 {
    font-family: var(--title-font);
    font-weight: 500;
    font-style: normal;
    text-transform: none;
    font-size: 50px;
    line-height: 58px;
    letter-spacing: 0;
    color: #fff;
    @media only screen and (max-width: 767px){
      font-size: 35px;
	   }
  }

  .contactBtn{
    margin-top: 40px;
  	color: #fff0f5;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    text-transform: none;
    line-height: 1.4;
    letter-spacing: 0;
    z-index: 10;
    
      span:hover {
        cursor: pointer;
      }
      
      span::after {
        display: inline-block;
        position: relative;
        z-index: 4;
        content: "";
        background: #fff0f5;
        width: 100%;
        height: 5px;
        position: absolute;
        bottom: -4px;
        left: 0;
      }
    }
`;

const Contact = () => {
  return (
    <StyledContactSection id="contact">
      <h3><span>Let’s build the next<br/> big thing together</span></h3>
      <Link className="contactBtn" to='/contact'>
        <span>Start a new project</span>
      </Link>
    </StyledContactSection>
  );
};

export default Contact;
